var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_191",
    "data-name": "Ret\\xE2ngulo 191",
    width: 58,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pix",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pix-2",
    "data-name": "pix"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_196",
    "data-name": "Ret\\xE2ngulo 196",
    stroke: "#e7e7e7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2376",
    d: "M567.249,76.326a3.983,3.983,0,0,1-2.834-1.173l-4.092-4.092a.778.778,0,0,0-1.075,0l-4.107,4.107a3.983,3.983,0,0,1-2.834,1.173H551.5l5.182,5.182a4.144,4.144,0,0,0,5.861,0l5.2-5.2Z",
    transform: "translate(-530.612 -49.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2380",
    d: "M552.31,32.95a3.983,3.983,0,0,1,2.834,1.173l4.107,4.107a.761.761,0,0,0,1.075,0l4.092-4.092a3.983,3.983,0,0,1,2.834-1.173h.493l-5.2-5.2a4.144,4.144,0,0,0-5.861,0L551.5,32.95Z",
    transform: "translate(-530.613 -20.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2384",
    d: "M561.659,51.457l-3.141-3.14a.6.6,0,0,1-.223.045h-1.428a2.822,2.822,0,0,0-1.982.821l-4.091,4.092a1.966,1.966,0,0,1-2.777,0l-4.107-4.107a2.822,2.822,0,0,0-1.982-.821h-1.756a.6.6,0,0,1-.211-.043l-3.153,3.153a4.144,4.144,0,0,0,0,5.861l3.153,3.153a.6.6,0,0,1,.211-.043h1.756a2.822,2.822,0,0,0,1.982-.821l4.107-4.107a2.011,2.011,0,0,1,2.778,0l4.091,4.091a2.822,2.822,0,0,0,1.982.821H558.3a.6.6,0,0,1,.223.045l3.141-3.14a4.144,4.144,0,0,0,0-5.861",
    transform: "translate(-520.23 -34.386)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.909f35912285bbb2a077d6acee695eee.svg";
export { ForwardRef as ReactComponent };